module.exports = __webpack_public_path__ + "img/logoTB.e3c885f4.png";